import { useEffect, useState } from "react";
import { Input } from "@/components/ui/input";
import { formatInches, parseInches } from "@/lib/measure";

// Dimension field that reads like a tape: shows 25 1/2, accepts "25 1/2", "25-1/2", "1/2" or 25.5,
// commits the decimal on Enter / blur. `value` is the stored decimal (or "" when allowEmpty).
export const MeasureInput = ({
  value,
  onChange,
  allowEmpty = false,
  min = null,
  max = null,
  fallback = 0,
  className = "",
  ...rest
}) => {
  const shown = (v) =>
    v === "" || v === null || v === undefined
      ? ""
      : formatInches(v, { unit: false });
  const [text, setText] = useState(shown(value));
  const [editing, setEditing] = useState(false);

  useEffect(() => {
    if (!editing) setText(shown(value));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value, editing]);

  const commit = () => {
    setEditing(false);
    const raw = text.trim();
    if (!raw) {
      if (allowEmpty) {
        onChange("");
        setText("");
      } else {
        onChange(fallback);
        setText(shown(fallback));
      }
      return;
    }
    let n = parseInches(raw);
    if (n === null) {
      setText(shown(value));
      return;
    }
    if (min !== null && n < min) n = min;
    if (max !== null && n > max) n = max;
    onChange(n);
    setText(shown(n));
  };

  return (
    <Input
      {...rest}
      type="text"
      inputMode="decimal"
      value={text}
      onFocus={(e) => {
        setEditing(true);
        rest.onFocus?.(e);
      }}
      onChange={(e) => setText(e.target.value)}
      onBlur={commit}
      onKeyDown={(e) => {
        if (e.key === "Enter") {
          e.preventDefault();
          e.currentTarget.blur();
        }
        if (e.key === "Escape") {
          setText(shown(value));
          e.currentTarget.blur();
        }
        rest.onKeyDown?.(e);
      }}
      className={`font-mono-data ${className}`}
      title='Type 25 1/2, 25-1/2, 1/2 or 25.5'
    />
  );
};
